import { putResolve } from '@redux-saga/core/effects';
import { PayloadAction, createSelector, createSlice } from '@reduxjs/toolkit';
import { refreshUserSaga } from './userSlice';

export const initialState = {
  accessToken: '',
  refreshToken: '',
  refreshing: false,
};

const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    changeTokens(
      state,
      action: PayloadAction<{
        accessToken: string;
        refreshToken: string;
      }>,
    ) {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
    },
    toggleRefreshing(state) {
      state.refreshing = !state.refreshing;
    },
    loadTokens() {},
  },
});

export const { actions: authActions, reducer: authReducer } = slice;

const selectDomain = (state: { auth: any }) => state.auth || initialState;

export const selectAccessToken = createSelector(
  [selectDomain],
  authState => authState.accessToken,
);

export const selectRefreshToken = createSelector(
  [selectDomain],
  authState => authState.refreshToken,
);

export const selectRefreshing = createSelector(
  [selectDomain],
  authState => authState.refreshing,
);

export const INIT_TOKEN_SAGA = 'INIT_TOKEN_SAGA';

export function* initTokenSaga(): Generator<any, any, any> {
  const action = authActions.changeTokens({
    accessToken: '',
    refreshToken: '',
  });
  yield putResolve(action);
  if (window.location.pathname !== '/login') {
    alert('로그인이 만료됐습니다.');
    window.location.href = '/login';
  }
}

export const CHANGE_TOKENS = 'CHANGE_TOKENS';
export function* changeTokensSaga({ payload }: any) {
  yield putResolve(authActions.changeTokens(payload));
  yield refreshUserSaga();
}
